import { render, staticRenderFns } from "./AnliInteraction.vue?vue&type=template&id=492785fb&scoped=true&"
import script from "./AnliInteraction.vue?vue&type=script&lang=js&"
export * from "./AnliInteraction.vue?vue&type=script&lang=js&"
import style0 from "./AnliInteraction.vue?vue&type=style&index=0&id=492785fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492785fb",
  null
  
)

component.options.__file = "AnliInteraction.vue"
export default component.exports